<template>
  <div class="custom-actions">
    <div class="input-group mb-3">
        <input type="number" class="form-control" v-model="datas.inicio" placeholder="Início" v-on:blur="validarData">
        <div class="input-group-prepend">
          <span class="input-group-text">Até</span>
        </div>
        <input type="number" class="form-control" v-model="datas.fim" placeholder="Fim" readonly>
        <div class="input-group-append">
          <button class="btn btn-success" type="button" title="Salvar" v-on:click="salvar">
            <i class="icon-check"></i>
          </button>
        </div>
      </div>
  </div>
</template>

<script>
  import Uteis from '@/mixins/utils.js';

  export default {
    name: 'actions-gitlab',

    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        datas: {
          inicio: '',
          fim: '',
        },
      };
    },

    mounted() {
      this.datas.inicio = this.rowData.inicio_competencia || '';
      this.datas.fim = this.rowData.fim_competencia || '';
    },

    methods: {
      validarData() {
        if (!this.datas.inicio) {
          return this.datas.fim = '';
        }

        if (this.datas.inicio > 31) {
          this.datas.inicio = 31;
        } else if (this.datas.inicio <= 1) {
          return this.datas = { inicio: 1, fim: 31 };
        }

        this.datas.fim = this.datas.inicio - 1;
      },

      async salvar() {
        try {
          const { data: response} = await this.$http.post('/cliente-cc', this.getDTO());

          this.notificar('Registro atualizado com sucesso!', 'sincronizar-competencia', 'success');
        } catch(e) {
          this.notificar('Ocorreu um erro ao salvar o registro!', 'sincronizar-competencia');
        } finally {
          this.$parent.reload();
        }
      },

      getDTO() {
        return {
          id: this.rowData.id,
          inicio_competencia: this.datas.inicio,
          fim_competencia: this.datas.fim,
        };
      },

      editar (data, index) {
        this.$router.push({ path: `/gestor/usuarios/${data.id}` });
      }
    }
  }
  </script>
